export * from './feld-option-gespeichert.interface';
